<template>
  <div id="app">
    <router-view />
    
    <!-- DatePicker 컴포넌트가 렌더링 될 PortalTarget 컴포넌트를 date-picker-target 요소 내부에 동적으로 생성 -->
    <div id="date-picker-target"></div>
  </div>
</template>

<script>
import config from '@/config'
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed: {},
  mounted() {},
  methods: {},
  created() {
    const userInfo = sessionStorage.getItem('userInfo')
    if (userInfo && JSON.parse(userInfo).hasOwnProperty('partner')) {
      this.$store.commit('authentication/SET_USER', JSON.parse(userInfo))
    } else {
      if (this.$route.name !== 'Login') {
        this.$router.replace('/login')
      }
    }
  }
}
</script>

<style src="./styles/theme.scss" lang="scss" />
